import { useState } from "react";
import { TypeaheadInput } from "@jsq/ds/core";
import * as styles from "./styles_vanilla.css";
import { useAssignableStaffSearch } from "./useAssignableStaffSearch";

export type AssignedToPickerProps = {
  currentAssigneeName?: string;
  onSelectAssignee: (assigneeId: string) => void;
  // Omit to keep this picker assign-only.
  onUnassign?: () => void;
  disabled?: boolean;
};

export const AssignedToPicker = ({
  currentAssigneeName,
  onSelectAssignee,
  onUnassign,
  disabled,
}: AssignedToPickerProps) => {
  const [search, setSearch] = useState("");
  const { options, isLoading } = useAssignableStaffSearch(search);

  return (
    <div className={styles.assignedToPickerWrapper}>
      <TypeaheadInput
        options={options}
        initialSearchValue={currentAssigneeName}
        onDebouncedSearch={setSearch}
        onSelectOption={(option) => onSelectAssignee(String(option.id))}
        isLoading={isLoading}
        disabled={disabled}
        placeholder="Select assignee"
        isFullWidth
        // Only offer clear when there's an assignee to clear and unassign is allowed.
        isClearable={onUnassign != null && currentAssigneeName != null}
        onClearValue={onUnassign}
        data-testid="ddq-drawer-assigned-to-picker"
      />
    </div>
  );
};
